import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FileNewIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.18 13.96H16.54V9.94H12.32V5.72H7.46V18.2H12.26V19.84H5.82V4.08H13.52L18.18 8.74V13.96ZM17.34 22.58C15.34 22.58 13.74 20.98 13.74 19.02C13.74 17.06 15.34 15.46 17.34 15.46C19.34 15.46 20.94 17.06 20.94 19.02C20.94 20.98 19.34 22.58 17.34 22.58ZM16.76 20.94H17.92V19.58H19.28V18.42H17.92V17.06H16.76V18.42H15.4V19.58H16.76V20.94Z" />
    </SvgIcon>
  );
});
